import axios from "axios";
import { Constants } from "../utils/Constants";

const BASE_URL = `${Constants.baseUrl}/viagens`;

export const getDataTable = (event) => axios.post(`${BASE_URL}/list`, event);

export const get = (id) => axios.get(`${BASE_URL}/${id}`);

export const store = (data) => axios.post(BASE_URL, data);

export const cancelar = (id) => axios.post(`${BASE_URL}/${id}/cancelar`);

export const getTaxaCancelamento = (id) => axios.get(`${BASE_URL}/${id}/taxa-cancelamento`);

export const exportarRelatorio = (data) => axios.post(`${BASE_URL}/exportar-relatorio`, data, { responseType: "blob" });

export const gerarRecibo = (id) => axios.get(`${BASE_URL}/${id}/recibo`);
